export enum ExperienceContentType {
  Hotel = 'hotel',
  Villa = 'villa',
  Place = 'place',
  Experience = 'experience',
  BookingExperienceModule = 'bookingexperiencemodule',
}
